import { forwardRef } from 'react';
import type { ComponentProps, ForwardRefExoticComponent, RefAttributes } from 'react';

import { GradientButton } from './GradientButton';

type Props = Omit<ComponentProps<typeof GradientButton>, 'styleRound'>;

interface CompoundedComponent extends ForwardRefExoticComponent<
  Props & RefAttributes<HTMLButtonElement>
> {
  S: typeof GradientButton.S;
  Icon: typeof GradientButton.Icon;
  Text: typeof GradientButton.Text;
}

export const GradientButtonRound = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  return <GradientButton {...props} ref={ref} styleRound={true} />;
}) as CompoundedComponent;

GradientButtonRound.Icon = GradientButton.Icon;
GradientButtonRound.Text = GradientButton.Text;
GradientButtonRound.S = GradientButton.S;
